import { graphql } from "../../../models/autogenerated-deliveryService-gql";

export const RefreshAccessMutation = graphql(/* GraphQL */ `
  mutation refreshAccess($refreshAccessInput: RefreshInput!) {
    refresh(input: $refreshAccessInput) {
      ...RefreshPayload
    }
  }
`);
